// Hand the browser a text file to save. Exports are built client-side from
// the cached JSON reports (the API only speaks JSON behind a bearer token, so
// a plain download link would carry no auth).
export function downloadText(filename, text, mime = 'text/plain;charset=utf-8') {
  const blob = new Blob([text], { type: mime });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
